/**
 * 이력 통계 기간 모델 — 상대(최근 N일) / 절대(from~to 날짜) 두 모드.
 *
 * 백엔드 계약 (top-problem-* 엔드포인트 공통):
 *   relative → ?days=N
 *   absolute → ?from=YYYY-MM-DD&to=YYYY-MM-DD  (양끝 날짜 포함, from 이 있으면 days 무시)
 */
export type TimeRange =
  | { kind: "relative"; days: number }
  | { kind: "absolute"; from: string; to: string }; // YYYY-MM-DD

export const DEFAULT_TIME_RANGE: TimeRange = { kind: "relative", days: 30 };

/** 쿼리스트링 조각 (선행 & 없음). */
export function timeRangeQuery(range: TimeRange): string {
  return range.kind === "relative"
    ? `days=${range.days}`
    : `from=${range.from}&to=${range.to}`;
}

/** TanStack Query 키용 직렬화 — 모드가 달라지면 키도 달라져야 캐시가 분리된다. */
export function timeRangeKey(range: TimeRange): string {
  return range.kind === "relative"
    ? `d${range.days}`
    : `${range.from}~${range.to}`;
}

/** "MM/DD" 표시용. */
function shortDate(iso: string): string {
  const [, m, d] = iso.split("-");
  return `${m}/${d}`;
}

/** 트리거 버튼/빈 결과 메시지용 사람이 읽는 라벨. */
export function timeRangeLabel(range: TimeRange): string {
  if (range.kind === "relative") return `최근 ${range.days}일`;
  return `${shortDate(range.from)} ~ ${shortDate(range.to)}`;
}

/** 오늘 날짜 YYYY-MM-DD (로컬 기준). */
export function todayIso(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
